import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const Footer = () => {
  const footerStyles = {
    footer: {
      background: "#001f3f",
      color: "#fff",
      padding: "60px 0 30px",
      borderTop: "4px solid #003366",
    },
    sectionTitle: {
      fontSize: "1.2rem",
      fontWeight: "700",
      textTransform: "uppercase",
      letterSpacing: "1px",
      marginBottom: "25px",
      color: "#fff",
      borderBottom: "2px solid #003366",
      paddingBottom: "10px",
      display: "inline-block",
    },
    text: {
      fontSize: "0.95rem",
      lineHeight: "2",
      color: "#e0e0e0",
      marginBottom: "12px",
    },
    link: {
      color: "#fff",
      textDecoration: "none",
      transition: "all 0.3s ease",
      fontWeight: "500",
    },
    navLink: {
      display: "block",
      color: "#e0e0e0",
      textDecoration: "none",
      padding: "8px 0",
      fontSize: "0.95rem",
      transition: "all 0.3s ease",
      borderLeft: "3px solid transparent",
      paddingLeft: "10px",
    },
    navLinkHover: {
      color: "#fff",
      borderLeft: "3px solid #fff",
      paddingLeft: "15px",
    },
    copyright: {
      borderTop: "1px solid #003366",
      paddingTop: "30px",
      marginTop: "40px",
      textAlign: "center",
      fontSize: "0.9rem",
      color: "#b0b0b0",
    },
    icon: {
      marginRight: "10px",
      color: "#003366",
    },
  };

  const customStyles = `
    .footer-link:hover {
      color: #fff !important;
      text-decoration: underline !important;
    }
    .footer-nav-link:hover {
      color: #fff !important;
      border-left: 3px solid #fff !important;
      padding-left: 15px !important;
    }
  `;

  return (
    <>
      <style>{customStyles}</style>
      <footer style={footerStyles.footer}>
        <Container>
          <Row>
            {/* Company Info */}
            <Col md={4} className="mb-4">
              <h5 style={footerStyles.sectionTitle}>Optwise Group</h5>
              <p style={footerStyles.text}>
                Australia's premier investment firm specializing in fiduciary
                and administration services. We deliver exceptional returns
                through strategic asset management.
              </p>
            </Col>

            {/* Quick Links */}
            <Col md={4} className="mb-4">
              <h5 style={footerStyles.sectionTitle}>Quick Links</h5>
              <Link
                to="/"
                style={footerStyles.navLink}
                className="footer-nav-link"
              >
                Home
              </Link>
              <Link
                to="/about"
                style={footerStyles.navLink}
                className="footer-nav-link"
              >
                About Us
              </Link>
              <Link
                to="/contact"
                style={footerStyles.navLink}
                className="footer-nav-link"
              >
                Contact
              </Link>
              <Link
                to="/faq"
                style={footerStyles.navLink}
                className="footer-nav-link"
              >
                FAQ
              </Link>
              <Link
                to="/tips"
                style={footerStyles.navLink}
                className="footer-nav-link"
              >
                Investment Tips
              </Link>
              <Link
                to="/how-to-invest"
                style={footerStyles.navLink}
                className="footer-nav-link"
              >
                How to Invest
              </Link>
            </Col>

            {/* Contact Info */}
            <Col md={4} className="mb-4">
              <h5 style={footerStyles.sectionTitle}>Contact Us</h5>
              <div style={footerStyles.text}>
                <strong>Address:</strong>
                <br />
                Level 12, 141 Walker Street
                <br />
                Sydney NSW 2060, Australia
              </div>
              <div style={footerStyles.text}>
                <strong>Phone:</strong>
                <br />
                <a
                  href="tel:0290520803"
                  style={footerStyles.link}
                  className="footer-link"
                >
                  02 9052 0803
                </a>
              </div>
              <div style={footerStyles.text}>
                <strong>Email:</strong>
                <br />
                <a
                  href="mailto:Admin@optwisegroup.com.au"
                  style={footerStyles.link}
                  className="footer-link"
                >
                  Admin@optwisegroup.com.au
                </a>
              </div>
            </Col>
          </Row>

          {/* Copyright */}
          <Row>
            <Col>
              <div style={footerStyles.copyright}>
                <p style={{ margin: 0 }}>
                  © {new Date().getFullYear()} Optwise Group. All Rights
                  Reserved.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
};

export default Footer;
